import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

/**
 * Chaikin's Volatility (FML.VOLATI) — painel próprio: linha do indicador +
 * linha de referência em zero. yAccessor(d) retorna o valor.
 */
class ChaikinVolatilitySeries extends Component {
  render() {
    const { yAccessor, stroke, strokeZeroLine, className } = this.props;
    return (
      <g className={className}>
        <LineSeries yAccessor={yAccessor} stroke={stroke} fill="none" />
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

ChaikinVolatilitySeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeZeroLine: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

ChaikinVolatilitySeries.defaultProps = {
  stroke: { color: "#FFFF00" },
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-chaikinvolatility-series",
};

export default ChaikinVolatilitySeries;
